import React, { useEffect, useState } from "react";
import axios from "axios";
import { useLocation, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import "../style/profilepage.css";
import ProfileLogo from "../assets/images/profileicon.png";
import { formatDmy } from "../utils/dateFormat";

const ProfilePage = () => {
  const navigate = useNavigate();
  const [errorMe, setErrorMe] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [getEmail, setGetEmail] = useState("");

  const [studentId, setStudentId] = useState("");
  const [fullName, setFullName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [dob, setDob] = useState("");
  const [address, setAddress] = useState("");
  const [city, setCity] = useState("");
  const [province, setProvince] = useState("");
  const [postal, setPostal] = useState("");
  const [sp, setSp] = useState("");
  const [church, setChurch] = useState("");
  const [otherChurch, setOtherChurch] = useState("");
  const [classType, setClassType] = useState("");
  const [dj, setDj] = useState("");
  const [role, setRole] = useState("");
  const [programs, setPrograms] = useState("");
  const [classes, setClasses] = useState({
    className: [],
  });
  const [tshirtSize, setTshirtSize] = useState("");
  const [joined, setJoined] = useState("");
  const [year, setYear] = useState("");
  const [q1, setQ1] = useState("");
  const [q2, setQ2] = useState("");
  const [q3, setQ3] = useState("");
  const [q4, setQ4] = useState("");
  const [q5, setQ5] = useState("");
  const [batchJoined, setBtachJoined] = useState("");

  const classOrder = [
    "OT",
    "NT",
    "BD",
    "BLC",
    "BCMF",
    "HH",
    "CBH",
    "CBD",
    "BWG",
    "MMM",
  ];

  const class1Year = [
    { name: "OT", status: "completed" },
    { name: "NT", status: "completed" },
    { name: "BD", status: "completed" },
    { name: "BLC", status: "completed" },
    { name: "BCMF", status: "completed" },
    { name: "MASTERCLASS", status: "completed" },
    { name: "HH", status: "completed" },
    { name: "CBH", status: "completed" },
    { name: "CBD", status: "completed" },
    { name: "BWG", status: "completed" },
    { name: "MMM", status: "completed" },
    { name: "CONFERENCE", status: "completed" },
  ];

  const handleCheckboxChange = (value) => {
    setClasses((prev) => {
      const exists = prev.className.find((c) => c.name === value);

      let updated;

      if (exists) {
        // jika status completed → tidak boleh dihapus
        // if (exists.status === "completed") {
        //   return prev;
        // }

        // jika requested → boleh dihapus
        updated = prev.className.filter((c) => c.name !== value);
      } else {
        // tambahkan kelas baru dengan status requested
        updated = [...prev.className, { name: value, status: "completed" }];
      }

      // sorting sesuai urutan kelas
      updated.sort(
        (a, b) => classOrder.indexOf(a.name) - classOrder.indexOf(b.name),
      );

      return {
        // ...prev,
        className: updated,
      };
    });
    // console.log(classes);
  };

  const handleCancel = async () => {
    const result = await Swal.fire({
      html: `
    Unsaved changes<br/>
    Do you want to cancel?
  `,
      icon: "question",
      background: "white",
      color: "black",
      backdrop: `rgba(131, 131, 131, 0.5)`,
      showCancelButton: true,
      confirmButtonColor: "#0004ff",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes",
      customClass: {
        confirmButton: "custom-btn-sweetalrt",
      },
    });
    if (result.isConfirmed) {
      navigate("/studentdatapage");
    } else if (result.isDismissed) {
    }
  };

  const handleSubmit = async () => {
    const result = await Swal.fire({
      text: "Do you want to save changes ?",
      icon: "question",
      background: "white",
      color: "black",
      backdrop: `rgba(131, 131, 131, 0.5)`,
      showCancelButton: true,
      confirmButtonColor: "#0004ff",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes",
      customClass: {
        confirmButton: "custom-btn-sweetalrt",
      },
    });
    if (result.isConfirmed) {
      let finalDj = dj;
      let finalRole = role;
      let finalClasses = classes;
      let finalYear = year;
      let finalq1 = q1;
      let finalq2 = q2;
      let finalq3 = q3;
      let finalq4 = q4;
      let finalq5 = q5;

      if (church !== "IFGF Bandung") {
        finalDj = "";
        finalRole = "";
      }

      if (programs === "1 Year Program") {
        finalClasses = {
          className: class1Year,
        };
      }

      try {
        const payload = {
          studentId: studentId,
          name: fullName,
          email: email,
          phoneNumber: phone,
          dateOfBirth: dob,
          address: address,
          city: city,
          province: province,
          postalCode: postal,
          studentPackage: sp,
          localChurch: church === "Others" ? otherChurch : church,
          lastDj: finalDj,
          role: finalRole,
          classType: classType,
          programs: programs,
          tshirtSize: tshirtSize,
          classes: finalClasses,
          joinedCEA: joined,
          year: finalYear,
          question1: finalq1,
          question2: finalq2,
          question3: finalq3,
          question4: finalq4,
          question5: finalq5,
          batchJoined: batchJoined,
        };

        await axios.patch(`/studentdashboard/${getEmail}`, payload);
        setIsLoading(false);

        Swal.fire({
          text: "Data Submitted.",
          icon: "success",
          background: "white",
          color: "black",
          backdrop: `rgba(131, 131, 131, 0.5)`,
          confirmButtonColor: "#0004ff",
          confirmButtonText: "OK",
        });
      } catch (error) {
        setIsLoading(false);
        Swal.fire({
          text: `${error.response.data.msg}`,
          icon: "error",
          background: "white",
          color: "black",
          backdrop: `rgba(131, 131, 131, 0.5)`,
          confirmButtonColor: "#0004ff",
          confirmButtonText: "OK",
        });
      }

      const result2 = await Swal.fire({
        text: "Data Saved!",
        icon: "success",
        background: "white",
        color: "black",
        backdrop: `rgba(131, 131, 131, 0.5)`,
        showCancelButton: false,
        confirmButtonColor: "#0004ff",
        confirmButtonText: "OK",
        customClass: {
          confirmButton: "custom-btn-sweetalrt",
        },
      });

      if (result2.isConfirmed) {
        window.location.reload();
      }
    } else if (result.isDismissed) {
    }
  };

  const getMe = async () => {
    try {
      const response = await axios.get("/mestudent");
      setGetEmail(response.data.email);
    } catch (error) {
      setErrorMe(true);
    } finally {
      setIsLoading(false);
    }
  };

  const getProfile = async () => {
    try {
      // const response = await axios.get(`/verifydata/${getEmail}`);
      const response = await axios.get(`/verifydatadashboard/${getEmail}`);
      // console.log(response);
      setStudentId(response.data.studentId);
      setFullName(response.data.name);
      setEmail(response.data.email);
      setPhone(response.data.phoneNumber);
      setDob(response.data.dateOfBirth);
      setAddress(response.data.address);
      setCity(response.data.city);
      setProvince(response.data.province);
      setPostal(response.data.postalCode);
      setSp(response.data.studentPackage);
      if (response.data.localChurch !== "IFGF Bandung") {
        setChurch("Others");
        setOtherChurch(response.data.localChurch);
      } else {
        setChurch(response.data.localChurch);
        setRole(response.data.role);
        setDj(response.data.lastDj);
      }
      setClassType(response.data.classType);
      setPrograms(response.data.program);
      setClasses(JSON.parse(response.data.classList));
      setTshirtSize(response.data.tshirtSize);
      setJoined("Yes");
      setYear(response.data.yearJoined);
      setQ1(response.data.question1);
      setQ2(response.data.question2);
      setQ3(response.data.question3);
      setQ4(response.data.question4);
      setQ5(response.data.question5);
    } catch (error) {
      // setErrorMe(true);
      const response = await axios.get(`/verifydatadashboard/${getEmail}`);
      const result = await Swal.fire({
        text: `${response.data.msg}`,
        icon: "warning",
        background: "white",
        color: "black",
        backdrop: `rgba(131, 131, 131, 0.5)`,
        showCancelButton: false,
        confirmButtonColor: "#fb3104",
        confirmButtonText: "Ok",
        customClass: {
          confirmButton: "custom-btn-sweetalrt",
        },
      });
      if (result.isConfirmed) {
        const response = await axios.delete("/logoutstudent");
        navigate("/loginstudent");
      }
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getMe();
  }, []);

  useEffect(() => {
    if (getEmail) {
      getProfile();
    }
  }, [getEmail]);

  const handleNavigate = (address) => {
    navigate(address);
  };

  useEffect(() => {
    if (errorMe) {
      Swal.fire({
        title: "Session Expired",
        text: "Please login to your account !",
        icon: "warning",
        background: "white",
        color: "black",
        backdrop: `rgba(131, 131, 131, 0.5)`,
        showCancelButton: false,
        confirmButtonColor: "#fb3104",
        confirmButtonText: "Ok",
        customClass: {
          confirmButton: "custom-btn-sweetalrt",
        },
      });

      navigate("/loginstudent");
    }
  }, [errorMe, navigate]);

  const Logout = () => {
    Swal.fire({
      title: "Logout",
      text: "Are you sure want to logout ?",
      icon: "warning",
      background: "white",
      color: "black",
      backdrop: `rgba(131, 131, 131, 0.5)`,
      showCancelButton: true,
      confirmButtonColor: "#0004ff",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes",
      customClass: {
        confirmButton: "custom-btn-sweetalrt",
      },
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const response = await axios.delete("/logoutstudent");
        } catch (error) {
        } finally {
          navigate("/loginstudent");
        }
      }
    });
  };
  return (
    <div className="custom-con-profilepage-sp d-flex justify-content-center align-items-center flex-column">
      <div className="custom-con-img-profile-sp position-relative">
        <img
          src={ProfileLogo}
          alt="profilelogo.png"
          className="adjust-img-profile-sp position-absolute top-50 start-50 translate-middle"
        />
      </div>
      <p className="custom-text-profile-title-name">{fullName}</p>
      <p className="custom-text-profile-title">{email}</p>
      <p className="custom-text-profile-title">{formatDmy(dob)}</p>
      <p className="custom-text-profile-title">{`Program: ${programs}`}</p>
      <div className="row align-items-center custom-row-btn-position-profile-sp">
        <div className="col-4 m-0 px-2">
          <button
            className="custom-btn-profile-left"
            onClick={() => handleNavigate("/editprofile")}
          >
            Update Profile
          </button>
        </div>
        <div className="col-4 m-0 px-2">
          <button
            className="custom-btn-profile-mid"
            onClick={() => handleNavigate("/forgotpassword")}
          >
            Change Password
          </button>
        </div>
        <div className="col-4 m-0 px-2">
          <button className="custom-btn-profile-right" onClick={() => Logout()}>
            Logout
          </button>
        </div>
      </div>
    </div>
  );
};

export default ProfilePage;
